import gql from 'graphql-tag';

export default gql`
query currentUser($userId: String) {
  currentUser {
    sandbox {
      vikaUser(userId: $userId) {
        session {
          name
          value
          expires
        }
        url
        spaceId
        userId
      }
    }
  }
  }
`;
